{
    "main_h1": "Nouvelles de et pour Zurich",
    "date_published": "Publié le",
    "date_modified": "Dernière mise à jour",
    "back_to_feed": "Retour à l'aperçu",
    "PROMOTION": "Promotion",
    "SOCIETY": "Société",
    "FREETIME": "Loisirs",
    "NEWS": "Actualités"
}